import BaseReducer from "./BaseReducer";

class SetupReducer extends BaseReducer {
  domain = "Setup";
  type = "Config";

  initialState = {
    mode: 1,
    version: "Guardian Mobile v2.3.4",
    useUserCodePin: true,
    pinLength: 4,
    userCodeLength: 6,
  };
}

const reducer = new SetupReducer();

export default reducer;
